import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { from } from 'rxjs';
import { UtilsService } from 'src/app/utils/utils.service';


export const homeGuard: CanActivateFn = (_, state) => {
    const router = inject(Router);
    const utilsService = inject(UtilsService);

    return from((async () => {
        const isAdmin = await utilsService.isExperianAdmin();
        if (isAdmin) return true;

        const correctPath = await utilsService.getCurrentUserHomePath();
        const currentRoute = state.url;

        if (currentRoute.startsWith(correctPath)) return true;

        await router.navigate(['error', '403']);
        return false;
    })());
};
